import React, {memo} from "../../../__snowpack__/pkg/react.js";
const Slow = memo((props) => {
  return /* @__PURE__ */ React.createElement("svg", {
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  }, /* @__PURE__ */ React.createElement("g", {
    id: "\u9875\u9762-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ React.createElement("g", {
    id: "\u4E3B\u5546\u54C1\u5217\u8868\u5907\u4EFD-6",
    transform: "translate(-751.000000, -600.000000)"
  }, /* @__PURE__ */ React.createElement("g", {
    id: "\u7F16\u7EC4\u5907\u4EFD-4",
    transform: "translate(751.000000, 599.999986)"
  }, /* @__PURE__ */ React.createElement("rect", {
    id: "\u77E9\u5F62",
    x: "0",
    y: "2.05128199e-05",
    width: "24",
    height: "24"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M12,1.50002051 C17.7944444,1.50002051 22.5,6.20557608 22.5,12.0000205 C22.5,17.7944649 17.7944444,22.5000205 12,22.5000205 C6.20555556,22.5000205 1.5,17.7944649 1.5,12.0000205 C1.5,6.20557608 6.20555556,1.50002051 12,1.50002051 Z M11.9519077,13.0216576 C8.56583961,13.0216576 6.9704806,15.4888568 6.69162437,16.0094889 L6.69162437,16.0094889 L6.6553246,16.081717 L6.64785696,16.0999014 C6.55314175,16.3366893 6.50578415,16.5734773 6.60049936,16.8102653 C6.69521457,17.0470533 6.83728736,17.2838413 7.07407533,17.3785565 C7.21614812,17.4259141 7.3582209,17.4732717 7.50029369,17.4732717 C7.87915445,17.4732717 8.21065763,17.2838413 8.35273042,16.9523381 C8.400088,16.8576229 9.44195512,14.9159615 11.9992653,14.9159615 C14.6039331,14.9159615 15.5984426,16.8576229 15.6458002,16.9523381 C15.8825882,17.4259141 16.4508793,17.6153444 16.9244553,17.3785565 C17.1612433,17.2364837 17.3033161,17.0470533 17.3980313,16.8102653 C17.4927464,16.5734773 17.4927464,16.2893318 17.2559585,16.0999014 C17.2086009,15.9578286 15.6931578,13.0216576 11.9519077,13.0216576 Z M7.54765127,7.24403093 C7.02671772,7.24403093 6.60049936,7.67024929 6.60049936,8.19118284 L6.60049936,8.19118284 L6.60049936,8.85418918 C6.60049936,9.37512275 7.0267177,9.80134112 7.54765127,9.80134112 C8.06858485,9.80134112 8.49480321,9.37512273 8.49480321,8.85418918 L8.49480321,8.85418918 L8.49480321,8.19118284 C8.49480321,7.67024929 8.06858482,7.24403093 7.54765127,7.24403093 Z M16.4982369,7.24403093 C15.9773034,7.24403093 15.551085,7.67024929 15.551085,8.19118284 L15.551085,8.19118284 L15.551085,8.85418918 C15.551085,9.37512275 15.9773034,9.80134112 16.4982369,9.80134112 C17.0191705,9.80134112 17.4453889,9.37512273 17.4453889,8.85418918 L17.4453889,8.85418918 L17.4453889,8.19118284 C17.4453889,7.67024929 17.0191705,7.24403093 16.4982369,7.24403093 Z",
    id: "\u5F62\u72B6\u7ED3\u5408",
    fill: "#ADBACC",
    fillRule: "nonzero"
  })))));
});
export default Slow;
